import {FC} from "react";
import {PageBase} from "../../components/pageBase/pageBase";
import {CourseLibraryBanner} from "./CourseLibraryBanner";
import {makeStyles} from "tss-react/mui";
import LibraryContent from "./LibraryContent";
import {Box} from "@mui/material";
import CustomLibraryContent from "./CustomLibraryContent";
import useDevCycleSdk from "../../hooks/useDevCycleSdk";

const useStyles = makeStyles()((theme) => ({
	pageBase: {
		[theme.breakpoints.up("lg")]: {
			"& [class*='menuIcon']": {
				display: "none"
			}
		},
		[theme.breakpoints.down("sm")]: {
		}
	},
	container: {
		[theme.breakpoints.up("sm")]: {
			padding: "0 0px"
		}
	},
	library: {
		paddingBottom: "70px",
		width: "100%"
	}
}));

export const CourseLibraryPage: FC = () => {
	const {classes} = useStyles();
	const {meiliSearchIntegration} = useDevCycleSdk();

	return (
		<PageBase className={classes.pageBase} contentWidth="100%" disableSideBar>
			<Box className={classes.container}>
				<CourseLibraryBanner />
				{meiliSearchIntegration ? (
					<CustomLibraryContent
						className={classes.library}
					/>
				) : (
					<LibraryContent
						className={classes.library}
					/>
				)}
			</Box>
		</PageBase>
	);
}